<template>
  <default>
    <div class="tw-w-full">
      <bread-crumb />
      <v-card flat class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4 tw-mt-4 md:tw-mt-4 tw-flex tw-justify-center tw-flex-col">

        <div class="tw-w-full tw-flex tw-mt-3 md:tw-mt-6 tw-justify-center tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-px-0 md:tw-px-4 tw-mt-4 md:tw-mt-8 tw-pb-8">
          <div v-if="isAuthenticated" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-py-4">
            <div>
              <avatar-icon :username="authenticatedUser.name" :size="100" color="#fff" backgroundColor="#114cac" />
            </div>
            <div class="tw-px-0 md:tw-px-4 xl:tw-px-16">
              <h2 class="c-navy-text tw-text-xl lg:tw-text-2xl xl:tw-text-3xl">Hello {{authenticatedUser.name}}</h2>
              <h4 class="c-light-blue-text tw-text-base lg:text-base xl:tw-text-xl">Welcome to Pacis Insurance</h4>
              <h5 class="c-blue-text">Buy, Renew or claim against your policy within minutes</h5>
            </div>
          </div>
          <div class="tw-flex">
            <div class="tw-flex tw-w-full tw-justify-end tw-px-0 md:tw-px-4">
              <v-card flat color="primary" class="tw-w-full md:tw-w-auto tw-p-3 tw-flex tw-justify-between tw-rounded-lg">
                <div class="tw-flex tw-justify-end tw-flex-col tw-text-right">
                  <p class="c-white-text tw-font-bold tw-text-xl">Need an Insurance Cover?</p>
                  <h2 class="c-white-text tw-font-light">Get your quote instantly</h2>
                  <v-btn id="get-quote" small class="mt-2 tw-w-3/4 tw-self-end" color="warning" :to="{name: 'Request', query: { toRfq: true }}">Request a Quote</v-btn>
                </div>
              </v-card>
            </div>

            <div class="tw-flex tw-w-full tw-justify-start tw-mt-6 md:tw-mt-0 tw-px-0 md:tw-px-4">
              <v-card flat color="secondary" class="tw-p-3 tw-w-full md:tw-w-auto tw-rounded-lg tw-flex tw-justify-between">
                <div class="tw-flex tw-justify-end tw-flex-col tw-text-right">
                  <p class="c-white-text tw-text-xl tw-font-bold">Need to report a claim?</p>
                  <h2 class="c-white-text tw-font-light">Easy claims, no worries</h2>
                  <v-btn id="report-claim" :to="{name: 'Claims'}" small class="mt-2 tw-self-end" color="#fff">Report a Claim</v-btn>
                </div>
              </v-card>
            </div>
          </div>
        </div>

        <div v-if="quotesLength > 0" class="tw-w-full tw-flex tw-justify-center tw-flex-col tw-pb-8">
          <div class="tw-w-full">
            <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">My Recent Quotes</h3>
            <hr class="tw-mt-3 tw-mb-5">
          </div>
          <quotes @saved-quotes-loaded="quotesLoaded" />
        </div>
      </v-card>
    </div>
  </default>
</template>

<script>

import Default from '@/components/layout/Default';
import BreadCrumb from '@/components/dashboard/BreadCrumb';
import { mapGetters } from 'vuex';
import Quotes from '@/components/quotes/Quotes';
import AvatarIcon from 'vue-avatar';

export default {
  components: {
    Quotes, BreadCrumb, Default, AvatarIcon,
  },
  data() {
    return {
      quotesLength: 1,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser', 'isAuthenticated']),
  },
  metaInfo: {
    title: 'Dashboard',
  },
  methods: {
    quotesLoaded(quotes) {
      this.quotesLength = quotes.length;
    },
  },
};
</script>
